<template>
  <div>
    <Modal :title="title" v-model="visible" width="600" class="my-modal top" :mask-closable="false" :footer-hide="true" @on-visible-change="changeVisible">
      <Form ref="form" v-if="visible" :model="formData" class="page-form" :label-width="type == 6 ? 140 : 100">
        <FormItem prop="name" key="name" label="姓名" class="half">
          <span>{{ name }}</span>
        </FormItem>
        <FormItem prop="staffNo" key="staffNo" label="工号" class="half">
          <span>{{ staffNo }}</span>
        </FormItem>
        <template v-if="type == 1">
          <FormItem prop="oldIfaLevel" key="oldIfaLevel" label="当前职级" class="half">
            <lzDicTxt dicType="IFA_RANK" :dicCode="formData.oldIfaLevel" />
          </FormItem>
          <FormItem key="isLeader" prop="isLeader" label="是否团队长" class="flex">
            {{ formData.isLeader == '1' ? '是' : '否' }}
          </FormItem>
          <FormItem key="type" prop="type" label="晋升类型" class="half" :rules="$units.formRule.required('请选择晋升类型')">
            <!-- 为团队长 且 团队长级别为高级合伙人 不能合伙人晋升 -->
            <Select v-model="formData.type" transfer>
              <Option
                v-for="(item, index) in typeList"
                :value="item.value"
                :disabled="formData.isLeader === '1' && item.value == '2' && groupLevel == 2"
                :key="index"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
          <FormItem
            v-if="formData.type == 2"
            key="groupLevel"
            prop="groupLevel"
            label="团队长级别"
            class="half"
            :rules="$units.formRule.required('请选择团队长级别')"
          >
            <Select v-model="formData.groupLevel" transfer>
              <Option v-for="(item, index) in groupLevelList" :disabled="formData.isLeader === '1' && groupLevel == 1 && item.value == 1" :value="item.value" :key="index">{{
                item.label
              }}</Option>
            </Select>
          </FormItem>
          <FormItem
            v-if="formData.type == 1"
            prop="ifaLevel"
            key="ifaLevel"
            label="变更后职级"
            class="half"
            :rules="$units.formRule.required('请选择变更职级')"
          >
            <Select v-model="formData.ifaLevel" transfer clearable filterable>
              <Option v-for="(item, index) in rankList" :disabled="Number(item.value) <= Number(formData.oldIfaLevel)" :value="item.value" :key="index">{{
                item.txt
              }}</Option>
            </Select>
            <!-- <lzDicSelect v-model="formData.ifaLevel" dicType="IFA_RANK" :transfer="true"> </lzDicSelect> -->
          </FormItem>
          <FormItem v-if="formData.type == 2" prop="trainerId" key="trainerId" label="育成人" class="half">
            <Select v-model="formData.trainerId" transfer clearable filterable>
              <Option v-for="(item, index) in refereeList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </template>
        <template v-else-if="type == 4">
          <FormItem prop="oldIfaLevel" key="oldIfaLevel" label="当前职级" class="half">
            <lzDicTxt dicType="IFA_RANK" :dicCode="formData.oldIfaLevel" />
          </FormItem>
          <FormItem key="isLeader" prop="isLeader" label="是否团队长" class="flex">
            {{ formData.isLeader == '1' ? '是' : '否' }}
          </FormItem>
          <FormItem key="type" prop="type" label="降级类型" class="half" :rules="$units.formRule.required('请选择降级类型')">
            <Select v-model="formData.type" transfer @on-change="changeType">
              <Option
                v-for="(item, index) in typeList"
                :value="item.value"
                :disabled="
                  (type == 1 && formData.isLeader == '1' && item.value == '2') ||
                  (type == 4 && formData.isLeader == '0' && (item.value == '2' || item.value == '3')) ||
                  (type == 4 && formData.isLeader == '1' && item.value == '3' && groupLevel == 1)
                "
                :key="index"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>

          <FormItem
            v-if="formData.type == 3"
            key="groupLevel"
            prop="groupLevel"
            label="团队长级别"
            class="half"
            :rules="$units.formRule.required('请选择团队长级别')"
          >
            <Select v-model="formData.groupLevel" transfer>
              <Option v-for="(item, index) in groupLevelList" :disabled="groupLevel == 2 && item.value == 2" :value="item.value" :key="index">{{
                item.label
              }}</Option>
            </Select>
          </FormItem>
          <FormItem
            v-if="formData.type == 1"
            prop="ifaLevel"
            key="ifaLevel"
            label="变更后职级"
            class="half"
            :rules="$units.formRule.required('请选择变更职级')"
          >
            <Select v-model="formData.ifaLevel" transfer clearable filterable>
              <Option v-for="(item, index) in rankList" :disabled="Number(item.value) >= Number(formData.oldIfaLevel)" :value="item.value" :key="index">{{
                item.txt
              }}</Option>
            </Select>
            <!-- <lzDicSelect v-model="formData.ifaLevel" dicType="IFA_RANK" :transfer="true"> </lzDicSelect> -->
          </FormItem>
          <FormItem v-if="formData.type == 2" prop="trainerId" key="trainerId" label="育成人" class="half">
            <Select v-model="formData.trainerId" transfer clearable filterable>
              <Option v-for="(item, index) in refereeList" :value="item.id" :key="index">{{ item.name }}</Option>
            </Select>
          </FormItem>
        </template>
        <FormItem prop="effectiveDate" key="effectiveDate" label="生效日期" class="half flex" :rules="$units.formRule.objRequired('请选择')">
          <DatePicker v-model="formData.effectiveDate" format="yyyy-MM-dd" type="date" placeholder="请选择" transfer :options="options"> </DatePicker>
        </FormItem>
      </Form>
      <div class="ivu-modal-footer">
        <Button type="text" @click="visible = false">取消</Button>
        <Button type="primary" @click="save" :loading="loading">确认</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import lzDicTxt from '@/components/commons/lzDicTxt';
import lzDicSelect from '@/components/commons/lzDicSelect';
import dayjs from 'dayjs';
export default {
  components: {
    lzDicTxt,
    lzDicSelect
  },
  props: {},
  data() {
    return {
      rankList: [],
      refereeList: [],
      visible: false,
      loading: false,
      name: '',
      staffNo: '',
      groupLevel: '', //原团队长等级
      groupLevelList: [
        {
          label: '合伙人',
          value: '1'
        },
        {
          label: '高级合伙人',
          value: '2'
        }
      ],
      type: '', //1-晋升 2-维持 3-迁移 4-降级 5-停职 6-离职  7-复职
      formData: {
        oldIfaLevel: '', //当前职级
        userId: '',
        type: '1', // 晋升类型 1=职级晋升 2=合伙人晋升
        ifaLevel: '', // 晋升等级 1=萌新 2=新贵 3=精英 4=王者
        trainerId: '0', //是否迁移
        effectiveDate: '' //
      },
      options: {
        disabledDate: this.disabledDate
      }
    };
  },
  computed: {
    typeList() {
      if (this.type == 1) {
        return [
          {
            label: '职级晋升',
            value: '1'
          },
          {
            label: '合伙人晋升',
            value: '2'
          }
        ];
      } else if (this.type == 4) {
        return [
          {
            label: '职级降级',
            value: '1'
          },
          {
            label: '团队长降级',
            value: '2'
          },
          {
            label: '团队长级别降级',
            value: '3'
          }
        ];
      }
    },
    saveUrl() {
      if (this.type == 1) {
        return '/buz/userBase/promote';
      } else if (this.type == 2) {
        return '维持';
      } else if (this.type == 3) {
        return '迁移';
      } else if (this.type == 4) {
        return '/buz/userBase/demote';
      } else if (this.type == 5) {
        return '停职';
      } else if (this.type == 6) {
        return '离职';
      } else if (this.type == 7) {
        return '复职';
      }
    },
    title() {
      if (this.type == 1) {
        return '晋升';
      } else if (this.type == 2) {
        return '维持';
      } else if (this.type == 3) {
        return '迁移';
      } else if (this.type == 4) {
        return '降级';
      } else if (this.type == 5) {
        return '停职';
      } else if (this.type == 6) {
        return '离职';
      } else if (this.type == 7) {
        return '复职';
      }
    }
  },
  created() {
    const dicData = JSON.parse(localStorage.dicData);
    this.rankList = dicData.IFA_RANK;
  },
  methods: {
    changeType(val) {
      if (val == '3' && this.groupLevel == '2') {
        this.formData.groupLevel = '1';
      }
    },
    getUserList() {
      this.$http({
        type: 'POST',
        url: '/buz/userBase/read/list',
        data: {
          pageSize: 9999,
          pageNo: 1,
          isAll: 1
        }
      }).then(res => {
        let list = res.data;
        this.refereeList = list.filter(item => item.id != this.formData.userId);
      });
    },
    changeVisible(val) {
      if (!val) {
        this.$emit('success');
      }
    },
    disabledDate(date) {
      if (this.type == '1' || this.type == '4') {
        // 晋升、降级弹窗中----生效日期限制为只能选择每个月1号
        return dayjs(date).format('DD') != '01' || dayjs(date).isAfter(dayjs());
      } else if (this.type == '6') {
        return false;
      } else {
        return dayjs(date).isBefore(dayjs()) && dayjs(date).format('YYYY-MM-DD') !== dayjs().format('YYYY-MM-DD');
      }
    },
    save() {
      this.$refs.form.validate().then(async isok => {
        if (!isok) {
          return;
        }
        const formData = JSON.parse(JSON.stringify(this.formData));
        if (formData.effectiveDate) formData.effectiveDate = dayjs(formData.effectiveDate).format('YYYY-MM-DD');
        this.$http({
          url: this.saveUrl,
          type: 'POST',
          data: formData
        }).then(res => {
          this.visible = false;
          this.$notice.success('操作成功');
        });
      });
    },
    open(data) {
      data = JSON.parse(JSON.stringify(data));
      console.log('data=-==', data);
      this.formData = {
        userId: '',
        type: '1',
        ifaLevel: '',
        trainerId: '0', //是否迁移
        effectiveDate: '',
        oldIfaLevel: '',
        isLeader: '',
        groupLevel: ''
      };
      this.visible = true;
      this.$refs.form && this.$refs.form.resetFields();
      this.name = data.name;
      this.staffNo = data.staffNo; //
      this.groupLevel = data.groupLevel; //
      this.formData.userId = data.id; //用户id
      this.formData.trainerId = data.trainerId; //育成人
      this.formData.oldIfaLevel = data.ifaLevel;
      this.formData.isLeader = data.isLeader;
      this.type = data.type; //更改类型
      this.getUserList();
    }
  }
};
</script>
<style lang="scss" scoped>
.dian {
  display: inline-block;
  width: 5px;
  height: 5px;
  background: #35bf3f;
  border-radius: 50%;
  margin-right: 4px;
  vertical-align: top;
  transform: translateY(7px);

  &.red {
    background: #e3461f;
  }
}

.my-modal {
  .error {
    color: #e3461f;
    margin-left: 10px;
  }

  .breed-name {
    margin-left: 10px;
  }

  /deep/.ivu-select {
    flex: 0 0 41.5%;
  }

  .flex {
    /deep/.ivu-form-item-content {
      display: flex;
    }

    .ivu-input-wrapper {
      flex: 0 0 41.5%;
    }
  }

  .btn-add {
    color: #236dff;
    cursor: pointer;
    margin-left: 10px;
  }

  .notice {
    margin-left: 10px;
    flex: 0 0 57%;
    width: 57%;
    display: inline-block;

    em {
      color: #e3461f;
      margin-right: 2px;
    }
  }

  .info-text {
    font-size: 12px;
    color: #a8adb7;
    line-height: 1.5;
    padding-top: 7px;
  }

  .password-icon {
    position: absolute;
    transform: translateX(-30px);
  }

  img.password-icon {
    width: 16px;
    top: 8px;
  }

  .ivu-icon-ios-eye {
    font-size: 18px;
    color: #a8adb7;
    top: 7px;
  }
}
.half {
  width: 50%;
}
</style>
